import { render, staticRenderFns } from "./BDXEditFormWrapper.vue?vue&type=template&id=46e03ba2"
import script from "./BDXEditFormWrapper.vue?vue&type=script&lang=js"
export * from "./BDXEditFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports